import React from 'react';

const PageNotFound: React.FC = () => <div>PageNotFound</div>;

export default PageNotFound;
